export default __webpack_public_path__ + "static/media/img10.cc62d3ee.png";